<template>

  <div class='Box'>
    <el-card class="box-card">
      <el-row :gutter="35">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" class="mb20">
          <div class="box-card boxss">
            <div data-v-f1ff0a02="" class="tit">
              ￥{{ headerData.new_register_recharge_money ? headerData.new_register_recharge_money : 0 }}
            </div>
            <div data-v-f1ff0a02="" class="dec">
              充值人数：{{ headerData.new_register_recharge_user ? headerData.new_register_recharge_user : 0 }}
            </div>
            <div data-v-f1ff0a02="" class="dec">
              充值笔数：{{ headerData.new_register_recharge_num ? headerData.new_register_recharge_num : 0 }}
            </div>
            <div data-v-f1ff0a02="" class="subscript">今日注册</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" class="mb20">
          <div class="box-card boxss">
            <div data-v-f1ff0a02="" class="tit">
              ￥{{ headerData.new_active_recharge_money ? headerData.new_active_recharge_money : 0 }}
            </div>
            <div data-v-f1ff0a02="" class="dec">
              充值人数：{{ headerData.new_active_recharge_user ? headerData.new_active_recharge_user : 0 }}
            </div>
            <div data-v-f1ff0a02="" class="dec">
              充值笔数：{{ headerData.new_active_recharge_num ? headerData.new_active_recharge_num : 0 }}
            </div>
            <div data-v-f1ff0a02="" class="subscript">今日激活</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" class="mb20">
          <div class="box-card boxss">
            <div data-v-f1ff0a02="" class="tit">
              ￥{{ headerData.total_recharge_money ? headerData.total_recharge_money : 0 }}
            </div>
            <div data-v-f1ff0a02="" class="dec">
              今日充值人数：{{ headerData.total_recharge_user ? headerData.total_recharge_user : 0 }}
            </div>
            <div data-v-f1ff0a02="" class="dec">
              今日充值笔数：{{ headerData.total_recharge_num ? headerData.total_recharge_num : 0 }}
            </div>
            <div data-v-f1ff0a02="" class="subscript">今日汇总充值</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" class="mb20">
          <div class="box-card boxss">
            <div data-v-f1ff0a02="" class="tit">￥{{ headerData.recharge_money ? headerData.recharge_money : 0 }}</div>
            <div data-v-f1ff0a02="" class="dec">总注册人数：{{ headerData.add_num ? headerData.add_num : 0 }}</div>
            <div data-v-f1ff0a02="" class="dec">总激活人数：{{ headerData.active_num ? headerData.active_num : 0 }}</div>
            <div data-v-f1ff0a02="" class="subscript">汇总充值</div>
          </div>
        </el-col>
      </el-row>

      <!-- 查询条件 -->
      <el-form :model="queryParams" size="medium" label-width="120px">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" class="mb20">
            <el-form-item label="渠道号">
              <SelectChecked :options="referralOptions" :isRemoveAllTag="isRemoveAllTag" placeholder="请选择渠道号"
                             @selectedVal="selectedReferral" :search="search"/>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" class="mb20">
            <el-form-item label="平台类型" prop="platform_type">
              <el-select v-model="queryParams.platform_type" placeholder="请选择平台类型" style="width: 100%;"
                         clearable @change="search" @clear="search">
                <el-option label="微信" :value=2></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" class="mb20">
            <el-form-item label="小程序名称">
              <el-input v-model="queryParams.app_name" placeholder="小程序名称" clearable @change="search" @clear="search"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" class="mb20">
            <el-form-item label="优化师">
              <el-input v-model="queryParams.optimizer_nickname" placeholder="优化师" clearable @change="search" @clear="search"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" class="mb20">
            <el-form-item label="渠道">
              <el-input v-model="queryParams.vip_nickname" placeholder="渠道" clearable @change="search" @clear="search"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" class="mb20">
            <el-form-item label="推广链接名称">
              <el-input v-model="queryParams.channel_name" placeholder="推广链接名称" clearable @change="search" @clear="search"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" class="mb20">
            <el-form-item label="小说名称">
              <el-input v-model="queryParams.movie_name" placeholder="小说名称" clearable @change="search" @clear="search"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" class="mb20">
            <el-form-item label="状态">
              <el-select v-model="queryParams.status" placeholder="请选择状态" clearable @change="search" @clear="search" class="w100">
                <el-option label="有效" :value=1></el-option>
                <el-option label="停投" :value=3></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="6" class="mb20">
            <el-form-item label="创建时间">
              <el-date-picker
                  style="width: 100%"
                  v-model="value1"
                  type="daterange"
                  align="right"
                  unlink-panels
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :picker-options="pickerOptions"
                  @change="search">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="6" class="mb20">
            <el-form-item label="总充值日期筛选">
              <el-date-picker
                  style="width: 100%"
                  v-model="value2"
                  type="daterange"
                  align="right"
                  unlink-panels
                  value-format="yyyy-MM-dd"
                  :default-time="['00:00:00', '23:59:59']"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :picker-options="pickerOptions"
                  @change="search">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button size="medium" type="primary" @click="search">查询</el-button>
              <el-button size="medium" @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>


      </el-form>
      <!--工具栏 -->
      <div class="div_buttom">
        <el-button size="medium" @click="getList">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-upload2" @click="exportExcel">导出</el-button>
        <!--        <el-button size="medium" type="primary" icon="el-icon-search" @click="addSearch">打开搜索</el-button>-->
      </div>
      <!-- 列表 -->
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                size="mini"
                :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                @selection-change="handleSelectionChange" border @sort-change="sortChange" v-loading="loading">

        <el-table-column label="渠道号" width="230">
          <template slot-scope="scope">{{ scope.row.channel_code }}</template>
        </el-table-column>
        <el-table-column prop="name" label="平台类型" width="80">
          <template slot-scope="scope">{{ scope.row.platform_type_text }}</template>
        </el-table-column>
        <el-table-column prop="app_name" label="小程序名称" width="100">
          <template slot-scope="scope">{{ scope.row.app_name }}</template>
        </el-table-column>
        <el-table-column prop="name" label="账号">
          <template slot-scope="scope">{{ scope.row.optimizer_username }}</template>
        </el-table-column>
        <el-table-column prop="name" label="优化师">
          <template slot-scope="scope">{{ scope.row.optimizer_nickname }}</template>
        </el-table-column>
        <el-table-column prop="name" label="渠道">
          <template slot-scope="scope">{{ scope.row.vip_nickname }}</template>
        </el-table-column>
        <el-table-column prop="name" label="商务" width="100">
          <template slot-scope="scope">{{ scope.row.business_nickname }}</template>
        </el-table-column>
        <el-table-column prop="name" label="入口页面" width="160">
          <template slot-scope="scope">
            {{ scope.row.movie_name }} {{ scope.row.episodes_name }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="推广链接名称" width="80">
          <template slot-scope="scope">{{ scope.row.channel_name }}</template>
        </el-table-column>
        <el-table-column prop="total_recharge_money_today" label="今日总充值金额" width="140" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.total_recharge_money_today ? scope.row.total_recharge_money_today : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="recharge_money" label="总充值金额" width="120" sortable="custom">
          <template slot-scope="scope">{{ scope.row.recharge_money ? scope.row.recharge_money : 0 }}</template>
        </el-table-column>
        <el-table-column prop="add_num_today" label="今日新增注册人数" width="160" sortable="custom">
          <template slot-scope="scope">{{ scope.row.add_num_today ? scope.row.add_num_today : 0 }}</template>
        </el-table-column>
        <el-table-column prop="new_register_recharge_user_today" label="今日新增注册充值人数" width="180"
                         sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.new_register_recharge_user_today ? scope.row.new_register_recharge_user_today : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="new_register_recharge_money_today" label="今日新增注册充值金额" width="180"
                         sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.new_register_recharge_money_today ? scope.row.new_register_recharge_money_today : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="average_recharge_per_person" label="今日新增注册人均充值" width="180" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.average_recharge_per_person ? scope.row.average_recharge_per_person : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="new_register_recharge_num_today" label="今日新增注册充值笔数" width="180"
                         sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.new_register_recharge_num_today ? scope.row.new_register_recharge_num_today : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="active_num_today" label="今日新增激活人数" width="160" sortable="custom">
          <template slot-scope="scope">{{ scope.row.active_num_today ? scope.row.active_num_today : 0 }}</template>
        </el-table-column>
        <el-table-column prop="new_active_recharge_user_today" label="今日新增激活充值人数" width="190"
                         sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.new_active_recharge_user_today ? scope.row.new_active_recharge_user_today : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="new_active_recharge_money_today" label="今日新增激活充值金额" width="190"
                         sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.new_active_recharge_money_today ? scope.row.new_active_recharge_money_today : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="new_active_recharge_num_today" label="今日新增激活充值笔数" width="190"
                         sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.new_active_recharge_num_today ? scope.row.new_active_recharge_num_today : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="total_recharge_money_yesterday" label="昨日充值金额" width="140" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.total_recharge_money_yesterday ? scope.row.total_recharge_money_yesterday : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="active_num_yesterday" label="昨日激活人数" width="140" sortable="custom">
          <template slot-scope="scope">{{
              scope.row.active_num_yesterday ? scope.row.active_num_yesterday : 0
            }}
          </template>
        </el-table-column>
        <el-table-column prop="total_recharge_user_yesterday" label="昨日充值人数" width="140" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.total_recharge_user_yesterday ? scope.row.total_recharge_user_yesterday : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="160" sortable="custom">
          <template slot-scope="scope">{{ scope.row.created_at ? scope.row.created_at : '-' }}</template>
        </el-table-column>
        <el-table-column prop="name" label="状态" width="80">
          <template slot-scope="scope">{{ formatState(scope.row.status) }}</template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="160">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="jumpToDetails(scope.row)">订单详情</el-button>
            <el-button type="text" size="medium" @click="openHistoryDetailDrawer(scope.row)">历史记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination
          v-show="total>0"
          :total="total"
          :page.sync="queryParams.pageNo"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
      />

    </el-card>

    <el-drawer
        :wrapperClosable="true"
        title="历史数据"
        :visible.sync="historyDetailDrawer"
        direction="rtl"
        size="60%"
    >
      <el-card>
        <template slot="title">
          <div class="drawer-title"><h2>历史数据</h2></div>
        </template>
        <el-table :data="historyData" tooltip-effect="dark" style="width: 100%"
                  @selection-change="handleSelectionChange" border size="medium"
                  :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}">
          <el-table-column prop="name" label="日期" width="100">
            <template slot-scope="scope">{{ scope.row.createdate }}</template>
          </el-table-column>
          <el-table-column prop="name" label="渠道号" width="240">
            <template slot-scope="scope">{{ scope.row.channel_code }}</template>
          </el-table-column>

          <el-table-column prop="name" label="新增注册人数" width="120">
            <template slot-scope="scope">{{ scope.row.add_num ? scope.row.add_num : 0 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="新增注册充值人数" width="160">
            <template slot-scope="scope">
              {{ scope.row.new_register_recharge_user ? scope.row.new_register_recharge_user : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="新增注册充值金额" width="160">
            <template slot-scope="scope">
              {{ scope.row.new_register_recharge_money ? scope.row.new_register_recharge_money : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="新增注册充值笔数" width="160">
            <template slot-scope="scope">
              {{ scope.row.new_register_recharge_num ? scope.row.new_register_recharge_num : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="新增激活人数" width="120">
            <template slot-scope="scope">{{ scope.row.active_num ? scope.row.active_num : 0 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="新增激活充值人数" width="160">
            <template slot-scope="scope">{{
                scope.row.new_active_recharge_user ? scope.row.new_active_recharge_user : 0
              }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="新增激活充值金额" width="160">
            <template slot-scope="scope">{{
                scope.row.new_active_recharge_money ? scope.row.new_active_recharge_money : 0
              }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="新增激活充值笔数" width="160">
            <template slot-scope="scope">{{
                scope.row.new_active_recharge_num ? scope.row.new_active_recharge_num : 0
              }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="总充值金额" width="120">
            <template slot-scope="scope">{{
                scope.row.total_recharge_money ? scope.row.total_recharge_money : 0
              }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="总充值笔数" width="120">
            <template slot-scope="scope">{{
                scope.row.total_recharge_num ? scope.row.total_recharge_num : 0
              }}
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-drawer>
  </div>


</template>

<script>
import {channelDateApi} from '@/api/statistics/channelData/index';
import {Session} from '@/utils/storage';
import {processErrors} from "@/utils/errorHandler";
import {GeneralCollectApi} from '@/api/statistics/comStatistics/index';
import SelectChecked from '@/components/Select/SelectChecked'

export default {
  components: {
    SelectChecked
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            end.setHours(23, 59, 59, 999); // 设置结束时间为当天的 23:59:59
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            start.setHours(0, 0, 0, 0); // 设置开始时间为当天的 00:00:00
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            end.setHours(23, 59, 59, 999); // 设置结束时间为当天的 23:59:59
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            start.setHours(0, 0, 0, 0); // 设置开始时间为当天的 00:00:00
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            end.setHours(23, 59, 59, 999); // 设置结束时间为当天的 23:59:59
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            start.setHours(0, 0, 0, 0); // 设置开始时间为当天的 00:00:00
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      // 创建日期
      value1: '',
      // 总充值日期筛选
      value2: '',
      // 历史记录
      historyData: [],
      // 历史记录抽屉
      historyDetailDrawer: false,
      // 表单标题
      title: "",
      // 表单
      form: {},
      // 表单宽度
      formLabelWidth: "140px",
      // 控制搜索显示
      SearchFlag: false,
      // 查询条件
      queryParams: {
        sortField: "",
        sortOrder: "",
        pageNo: 1,
        pageSize: 10
      },
      // 总条数
      total: 0,
      // 列表数据
      tableData: [],
      multipleSelection: [],
      // 头部数据
      headerData: {},
      referralOptions: [],//选择渠道号列表
      isRemoveAllTag: 0,//下拉框是否清空
      loading:false,
    };
  },
  created() {
    this.getSelectReferral();
    this.getList()
    // 获取头部数据
    this.getHeaderData();
  },
  methods: {
    /**
     * 选择渠道号
     */
    selectedReferral(value) {
      this.queryParams.channel_code = value;
    },
    /**
     * 获取选择渠道号列表
     */
    getSelectReferral() {
      const api = GeneralCollectApi();
      api.getSelectReferral()
          .then((res) => {
            if (res.code == 0) {
              let data = res.data;
              this.referralOptions = data.map(item => ({
                value: item.channel_code,
                label: item.channel_code,
                label_en: item.movie_name + '-' + item.episodes_name + '-' + item.channel_name,
                check: false
              }));
            } else {
              processErrors(res);
            }
          })
          .catch((error) => {
          });
    },
    // 格式化状态
    formatState(status) {
      switch (status) {
        case 1:
          return '有效'
        case 3:
          return '停投'
        default:
          return '未知'
      }
    },
    // 获取头部数据
    getHeaderData() {
      let api = channelDateApi()
      api.referralCollectHeader().then(res => {
        if (res.code == 0) {
          this.headerData = res.data
        } else {
          processErrors(res);
        }
      })
    },
    // 打开历史记录抽屉
    openHistoryDetailDrawer(row) {
      let api = channelDateApi();
      api.referralCollectHistory(row.id).then(res => {
        this.historyDetailDrawer = true
        this.historyData = res.data
      })
    },
    // 跳转详情
    jumpToDetails(row) {
      this.$router.push({
        path: '/Order/Order_Detils',
        query: {
          channel_code: row.channel_code
        },
      })
    },
    // 自定义排序
    sortChange(prop) {
      this.queryParams.sortField = prop.prop
      if (prop.order) {
        if (prop.order === 'ascending') {
          this.queryParams.sortOrder = 'asc'
        } else {
          this.queryParams.sortOrder = 'desc'
        }
      } else {
        this.queryParams.sortField = ''
        this.queryParams.sortOrder = ''
      }
      this.getList();
    },
    // 获取列表
    getList() {
      // 创建时间 value1
      if (this.value1) {
        this.queryParams.created_at_start = this.value1[0]
        this.queryParams.created_at_end = this.value1[1]
      }else{
        this.queryParams.created_at_start = ''
        this.queryParams.created_at_end = ''
      }
      // 总充值日期筛 value2
      if (this.value2) {
        this.queryParams.createdate_start = this.value2[0]
        this.queryParams.createdate_end = this.value2[1]
      }else{
        this.queryParams.createdate_start = ''
        this.queryParams.createdate_end = ''
      }
      this.loading = true
      let api = channelDateApi()
      api.referralCollect(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false
      })
    },
    // 点击查询
    search() {
      this.queryParams.pageNo = 1;
      this.getList();
    },
    // 重置按钮
    reset() {
      this.isRemoveAllTag += 1;
      this.queryParams = {
        pageNo: 1,
        pageSize: 10
      }
      this.value1 = []
      this.value2 = []
      this.getList();
    },
    // 搜索开关
    addSearch() {
      this.SearchFlag = !this.SearchFlag
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 导出
    exportExcel() {
      const params = {...this.queryParams};
      const urlParams = new URLSearchParams();
      // 处理日期范围
      if (this.value1.length) {
        params.create_time_start = this.value1[0];
        params.create_time_end = this.value1[1];
      }
      if (this.value2.length) {
        params.recharge_time_start = this.value2[0];
        params.recharge_time_end = this.value2[1];
      }
      // 将参数添加到 URLSearchParams 对象
      Object.keys(params).forEach(key => {
        if (params[key] && key !== 'pageNo' && key !== 'pageSize' && key !== 'sortField' && key !== 'sortOrder') {
          urlParams.append(key, params[key]);
        }
      });
      let url = new URL(window.location.href);
      let token = url.searchParams.get('token');
      if (token !== null) {
        urlParams.append('token', token)
      } else if (Session.get('token')) {
        urlParams.append('token', Session.get('token'))
      }
      // 获取基础 URL
      const baseExportUrl = process.env.VUE_APP_BASE_API + '/admin/referralcollect/export';
      // 拼接 URL 参数
      const fullExportUrl = baseExportUrl + '?' + urlParams.toString();
      window.location.href = fullExportUrl;
    }

  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>

.tit {
  font-size: 26px;
  font-weight: 700;
  width: 100%;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.dec {
  margin-top: 2px
}

.boxss {
  padding: 20px;
  -webkit-box-shadow: 0 0 6px rgba(15, 15, 15, .18823529411764706);
  box-shadow: 0 0 6px rgba(15, 15, 15, .18823529411764706);
  margin-bottom: 20px;
  position: relative
}

.subscript {
  position: absolute;
  color: #fff;
  background-color: #1890ff;
  -webkit-box-shadow: 2px -2px 6px rgba(110, 145, 179, .796078431372549);
  box-shadow: 2px -2px 6px rgba(110, 145, 179, .796078431372549);
  top: 10px;
  right: -6px;
  padding: 3px 10px 2px;
  border-radius: 3px;
}

.Box {
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

::v-deep .el-drawer__close-btn{
  font-size: 30px;
  font-weight: bold;
}
</style>

